<template>
	<div class="subtitle"><slot></slot></div>
</template>

<script setup></script>

<style scoped>
.subtitle {
	font-size: 1.2rem;
	font-weight: 300;
	line-height: 1.2;
}
</style>
